import { SfChevronForwardIcon } from 'fitify-ui/src/Icon/outline/SfChevronForwardIcon'

import {
  StyledContainer,
  StyledContent,
  StyledDevSlot,
  StyledHeaderUser,
  StyledIconButton,
} from './Header.Styled'
import type { HeaderProps } from './Header.Types'
import { Logo } from './Logo'
import { Stepper } from './Stepper/Stepper'

export const Header = ({
  devSlot,
  handlePreviousClick,
  stepper,
  user,
}: HeaderProps) => {
  if (user) {
    return (
      <StyledContainer $variant="user">
        <StyledContent>
          <Logo />
        </StyledContent>
        <StyledHeaderUser user={user} />
      </StyledContainer>
    )
  }

  return (
    <StyledContainer $variant="funnel">
      {handlePreviousClick && (
        <StyledIconButton
          data-testid="header-back-button"
          onClick={handlePreviousClick}
          size="x-large"
          variant="secondary"
        >
          <SfChevronForwardIcon style={{ transform: `rotate(-180deg)` }} />
        </StyledIconButton>
      )}
      <StyledContent>
        {stepper ? <Stepper {...stepper} /> : <Logo />}
      </StyledContent>
      {devSlot && <StyledDevSlot>{devSlot}</StyledDevSlot>}
    </StyledContainer>
  )
}
